import { render, staticRenderFns } from "./bindingUserInfoList.vue?vue&type=template&id=3a54bc5c&scoped=true&"
import script from "./bindingUserInfoList.vue?vue&type=script&lang=js&"
export * from "./bindingUserInfoList.vue?vue&type=script&lang=js&"
import style0 from "./bindingUserInfoList.vue?vue&type=style&index=0&id=3a54bc5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a54bc5c",
  null
  
)

export default component.exports